import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon } from 'shared/ui/icons';
import COLORS from 'shared/design-tokens/colors';
import { useBukuTarifLogDetail } from '../hooks/useBukuTarifLogDetail';
import { LogDetailCard } from '../components/log-detail-card';

const LogDetailPage = () => {
  const navigate = useNavigate();
  const { data } = useBukuTarifLogDetail();

  return (
    <main className="w-full pt-8 px-6 pb-4 gap-y-2 flex flex-wrap items-center">
      <header className="w-4/5 md:w-full">
        <nav aria-label="Breadcrumb" className="w-full flex items-center">
          <button
            type="button"
            onClick={() => navigate('/buku-tarif-log')}
            className="text-sm font-normal text-slate-500 cursor-pointer hover:text-slate-700"
          >
            Buku Tariff Log
          </button>
          <ArrowRightIcon color={COLORS.slate500} />
          <span className="text-sm font-medium text-slate-700 truncate">
            {data?.data?.tariff_book?.id}
          </span>
        </nav>
        <h1 className="text-2xl font-semibold">Buku Tariff Details</h1>
      </header>

      <section
        aria-labelledby="log-detail-heading"
        className="flex flex-col flex-grow justify-start overflow-auto bg-neutral-25"
      >
        <h2 id="log-detail-heading" className="sr-only">
          Log Details
        </h2>
        <LogDetailCard data={data} />
      </section>
    </main>
  );
};

export default LogDetailPage;
